import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { getContacts, getLoyaltyStats, getProgramCodes } from '../lib/api'

export const loyaltyKeys = {
	all: ['loyalty'] as const,
	stats: () => [...loyaltyKeys.all, 'stats'] as const,
	contactLists: () => [...loyaltyKeys.all, 'contacts'] as const,
	contacts: (search: string) => [...loyaltyKeys.contactLists(), search] as const,
	programCodes: (programId: number) => [...loyaltyKeys.all, 'program-codes', programId] as const,
}

export const loyaltyStatsQuery = () => queryOptions({ queryKey: loyaltyKeys.stats(), queryFn: getLoyaltyStats })

export const contactsQuery = (search: string) =>
	queryOptions({ queryKey: loyaltyKeys.contacts(search), queryFn: () => getContacts(search), placeholderData: keepPreviousData })

export const programCodesQuery = (programId: number) =>
	queryOptions({ queryKey: loyaltyKeys.programCodes(programId), queryFn: () => getProgramCodes(programId) })
